<template>
	<div class="book-debts">
		<table class="mx-auto" v-if="items.length">
			<tbody>
			<tr v-for="item of items">
				<td class="text-truncate text-right">{{item.debtor.name}}</td>
				<td class="text-truncate"
				    v-html="$formatMessage('debts_owes', {name:item.creditor.name})">
				</td>
				<td>{{item.amount | format-currency(book.currency)}}</td>
				<td v-if="payButton">
					<icon-button name="tick" @click="pay(item)"
					             :title="$formatMessage('debt_payback_tooltip')"
					             :disabled="saving"
					></icon-button>
				</td>
			</tr>
			</tbody>
			<tfoot>
			<tr>
				<td colspan="3">
					<small>{{$formatMessage('debts_when', {date:$formatDate(book.mtime)})}}</small>
				</td>
			</tr>
			</tfoot>
		</table>
		<slot v-else></slot>
	</div>
</template>

<script>
	import Card from 'ui/widgets/card';
	import IconButton from 'ui/widgets/icon-button';
	import solveDebts from 'core/debts-solver';
	import payDebt from 'ui/widgets/pay-debt';

	export default {
		components: {
			Card,
			IconButton
		},

		props: {
			book: Object,
			payButton: {type: Boolean, default: false}
		},

		data() {
			return {
				items: solveDebts(this.book.balance, this.book),
				saving: false
			};
		},

		watch: {
			'book.balance': function() {
				this.items = solveDebts(this.book.balance, this.book);
			}
		},

		methods: {
			pay(item) {
				payDebt(item, this);
			}
		}
	}
</script>

<style lang="scss">
	.book-debts {
		table {
			max-width: 45ex;
			width: 100%;
			tr {
				>* {
					line-height: 2.2;
				}
				>:first-child {
					max-width: 15ex;
					width: 15ex;
					padding-right: 1ex;
				}
				>:nth-child(2) {
					max-width: 20ex;
					width: 20ex;
				}
				>:last-child {
					text-align: right;
				}
			}
		}
	}
</style>


// WEBPACK FOOTER //
// src/ui/book-debts.vue